module.exports = __webpack_public_path__ + "static/media/Cartilla medica.9f3459f2.jpg";